// extracted by mini-css-extract-plugin
export var createButton = "TeamsAdminSection-module__createButton___mvX3G";
export var defaultBadge = "TeamsAdminSection-module__defaultBadge___EJF0E";
export var header = "TeamsAdminSection-module__header___SNtou";
export var infoCallout = "TeamsAdminSection-module__infoCallout___oAWsW";
export var section = "TeamsAdminSection-module__section___xhuBq";
export var spinnerContainer = "TeamsAdminSection-module__spinnerContainer___pKkwd";
export var statusAction = "TeamsAdminSection-module__statusAction___kl9G1";
export var statusActive = "TeamsAdminSection-module__statusActive___aeamH";
export var statusBadge = "TeamsAdminSection-module__statusBadge___DacC2";
export var statusInactive = "TeamsAdminSection-module__statusInactive___s9bCB";
export var subtitle = "TeamsAdminSection-module__subtitle___-6X-x";
export var table = "TeamsAdminSection-module__table___C4Byo";
export var tableContainer = "TeamsAdminSection-module__tableContainer___r39sX";
export var teamLink = "TeamsAdminSection-module__teamLink___4OSXb";
export var teamName = "TeamsAdminSection-module__teamName___l+B5y";
export var title = "TeamsAdminSection-module__title___riyh5";